/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Basic color scheme for components.
 */
export enum BASIC_COLOR_SCHEME {
  /**
   * Regular color scheme.
   */
  REGULAR = '',

  /**
   * Inverse color scheme.
   */
  INVERSE = 'inverse',
}

/**
 * Icon Placement.
 */
export enum ICON_PLACEMENT {
  /**
   * left of footer copy
   */
  LEFT = 'left',

  /**
   * right of footer copy
   */
  RIGHT = 'right',
}

/**
 * Constructor type. Used for defining mix-ins.
 */
export type Constructor<T> = new (...args: any[]) => T;
